:host {
    display: block;
}

.age-blur {
    filter: blur(.75rem);
}
